/**
 * En tête qui est affiché en haut
 * Permettant de changer les options
 */

import React from "react";
import { useI18n } from "../../I18nextProvider";

const Header = () => {
  const i18n = useI18n();

  return (
    <header>
      <a className="skip-main" href="#maincontent" tabIndex={0}>
        {i18n.t("global.skipToContent")}
      </a>
    </header>
  );
};

export default Header;
